"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_query_1 = require("@tanstack/react-query");
exports.default = () => {
    const { data: donorContactInformation } = (0, react_query_1.useQuery)({
        queryKey: ['GetDonorContactInformation'],
        queryFn: () => axios.get('/api/get-donor-contact-information').then((response) => response.data.data.filter((x) => x)),
    });
    return donorContactInformation || [];
};
